export enum TipoOperazioneSerieDocumentaleEnum {
  CREAZIONE = <any>"CREAZIONE",
  MODIFICA = <any>"MODIFICA",
  CHIUSURA = <any>"CHIUSURA",
  AGGIUNGI_UNITA_DOCUMENTARIA = <any>"AGGIUNGI_UNITA_DOCUMENTARIA",
}
